<section class="nhsuk-grid-row app-width content-section">
  @if (isAlertVisible) {
    <div
      id="alert"
      role="alert"
      aria-live="assertive"
      tabindex="-1"
      class="floating-alert"
      [ngClass]="{
        'alert-success': alertType === 'success',
        'alert-danger': alertType === 'danger',
        'alert-info': alertType === 'info',
      }"
    >
      <span class="mb-0">{{ alertMessage }}</span>
      <button class="close-btn" aria-label="Dismiss alert" (click)="dismissAlert()">×</button>
    </div>
  }

  <h2 #pageTitle class="nhsuk-heading-xl mb-16" tabindex="-1">Organisation Mapping</h2>
  <a routerLink="/admin/organisations-mapping/add">Add a new Organisation</a>

  <div class="nhsuk-grid-row mt-24">
    @let filteredOrganisations = organisationsContentArray | organisationFilter : orgCodeFilter : areaFilter;

    @if (!isLoading) {
      <div class="p-24 bg-white border-light-grey shadow-light-grey overflow-auto">
        <div class="nhsuk-grid-row mb-24">
          <div class="nhsuk-grid-column-one-third">
            <div class="nhsuk-form-group mb-0">
              <label class="nhsuk-label" for="orgCodeFilter">Filter by code</label>
              <input
                id="orgCodeFilter"
                class="nhsuk-input"
                type="text"
                [(ngModel)]="orgCodeFilter"
                placeholder="Enter organisation code"
              />
            </div>
          </div>

          <div class="nhsuk-grid-column-one-third">
            <div class="nhsuk-form-group mb-0">
              <label class="nhsuk-label" for="areaFilter">Filter Area</label>
              <input
                id="areaFilter"
                class="nhsuk-input"
                type="text"
                [(ngModel)]="areaFilter"
                placeholder="Enter Area"
              />
            </div>
          </div>

          <div class="nhsuk-grid-column-one-third d-flex align-end">
            <button
              type="button"
              class="nhsuk-button nhsuk-button--secondary mb-0"
              (click)="clearFilters()"
              [disabled]="!hasActiveFilters"
            >
              Clear filters
            </button>
          </div>
        </div>

        <table role="table" class="nhsuk-table-responsive">
          <caption class="nhsuk-table__caption">
            Total Organisations: {{ filteredOrganisations.length }}
            @if (hasActiveFilters) {
              <span> of {{ organisationsContentArray.length }}</span>
            }
          </caption>

          <thead role="rowgroup" class="nhsuk-table__head">
          <tr role="row">
            <th role="columnheader" scope="col">Code</th>
            <th role="columnheader" scope="col">Type</th>
            <th role="columnheader" scope="col">Authority</th>
            <th role="columnheader" scope="col">Contract</th>
            <th role="columnheader" scope="col">Area</th>
            <th role="columnheader" scope="col">Source ID</th>
            <th role="columnheader" scope="col">Action</th>
          </tr>
          </thead>

          <tbody class="nhsuk-table__body z-index-above">
            @for (result of filteredOrganisations; track result.orgMappingGuid) {
              <tr role="row" class="nhsuk-table__row">
                <td role="cell" class="nhsuk-table__cell">
                  <span class="nhsuk-table-responsive__heading" aria-hidden="true">
                    Organisation Code
                  </span>
                  {{ result.orgCode }}
                </td>

                <td role="cell" class="nhsuk-table__cell">
                  <span class="nhsuk-table-responsive__heading" aria-hidden="true">Type</span>
                  {{ result.type }}
                </td>

                <td role="cell" class="nhsuk-table__cell">
                  <span class="nhsuk-table-responsive__heading" aria-hidden="true">Authority</span>
                  {{ result.authorityType }}
                </td>

                <td role="cell" class="nhsuk-table__cell">
                  <span class="nhsuk-table-responsive__heading" aria-hidden="true">Contract</span>
                  {{ result.contract }}
                </td>

                <td role="cell" class="nhsuk-table__cell">
                  <span class="nhsuk-table-responsive__heading" aria-hidden="true">Area</span>
                  {{ result.area }}
                </td>

                <td role="cell" class="nhsuk-table__cell">
                  <span class="nhsuk-table-responsive__heading" aria-hidden="true">Source ID</span>
                  {{ result.dataSourceId }}
                </td>

                <td role="cell" class="nhsuk-table__cell">
                  <span class="nhsuk-table-responsive__heading" aria-hidden="true">Actions</span>
                  <span class="nhsuk-table-responsive__heading" aria-hidden="true">link to</span>

                  <a
                    [attr.aria-label]="'Link to ' + result.orgCode + ' edit page'"
                    [routerLink]="'edit/' + result.orgMappingGuid"
                  >
                    Edit
                  </a>

                  <button
                    class="link-button"
                    (click)="onDeleteOrg(result.orgMappingGuid)"
                    [attr.aria-label]="result.orgCode + ' delete'"
                  >
                    <span class="nhsuk-table-responsive__heading" aria-hidden="true">Action</span>
                    delete
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    @if (isLoading) {
      <div class="mt-16">
        <app-loading-spinner />
      </div>
    }

    @if (!isLoading && organisationsContentArray.length === 0) {
      <div class="mt-16">
        <p>No organisations found</p>
      </div>
    }

    @if (!isLoading && organisationsContentArray.length > 0 && filteredOrganisations.length === 0) {
      <div class="mt-16">
        <p>No organisations match the current filters</p>
      </div>
    }
  </div>
</section>
